import { useMemo } from "react";

import { useGetCasinoContainerConfigsQuery } from "@api/thirdPartyIntegration";
import { mapContainersToFilterItems } from "@pages/casino/utils/bettoContainers";
import { getUser } from "@utils";

const normalizeContainerPage = (containerPage) =>
	containerPage === "LiveCasino" ? "LiveCasino" : "Casino";

export const useBettoContainerFilterItems = (
	containerPage,
	languageCode,
	{ skip = false } = {}
) => {
	const page = normalizeContainerPage(containerPage);
	const username = getUser()?.username;
	const isSkipped = skip || window.TENANT !== "betto";

	const { data, isLoading, isFetching } = useGetCasinoContainerConfigsQuery(
		{ page, username },
		{ skip: isSkipped, refetchOnMountOrArgChange: true }
	);

	const items = useMemo(
		() => mapContainersToFilterItems(data?.containers, languageCode, page),
		[data?.containers, languageCode, page]
	);

	return {
		items,
		isLoading: isSkipped ? false : isLoading || isFetching,
	};
};

export const useBettoSidebarContainerItems = (languageCode) => {
	const username = getUser()?.username;
	const isSkipped = window.TENANT !== "betto";

	const {
		data: casinoData,
		isLoading: isCasinoLoading,
		isFetching: isCasinoFetching,
	} = useGetCasinoContainerConfigsQuery(
		{ page: "Casino", username },
		{ skip: isSkipped, refetchOnMountOrArgChange: true }
	);

	const {
		data: liveData,
		isLoading: isLiveLoading,
		isFetching: isLiveFetching,
	} = useGetCasinoContainerConfigsQuery(
		{ page: "LiveCasino", username },
		{ skip: isSkipped, refetchOnMountOrArgChange: true }
	);

	const containerItemsByKey = useMemo(
		() => ({
			casino: mapContainersToFilterItems(
				casinoData?.containers,
				languageCode,
				"Casino",
				"showInBurgerMenu"
			),
			"live-casino": mapContainersToFilterItems(
				liveData?.containers,
				languageCode,
				"LiveCasino",
				"showInBurgerMenu"
			),
		}),
		[casinoData?.containers, liveData?.containers, languageCode]
	);

	return {
		containerItemsByKey,
		casinoContainers: casinoData?.containers,
		isLoading: isSkipped
			? false
			: isCasinoLoading || isCasinoFetching || isLiveLoading || isLiveFetching,
	};
};
